/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useMemo } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Avatar from '@atlaskit/avatar/Avatar';
import Spinner from '@atlaskit/spinner';
import { TabPanel } from '@atlaskit/tabs';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { userListStyle, userStyle } from './styles';
var userDescriptionStyle = xcss({
  marginLeft: 'space.150'
});
var profileWrapperStyle = xcss({
  marginLeft: 'space.0'
});
var reactionViewStyle = xcss({
  marginTop: 'space.150',
  minHeight: '300px',
  minWidth: '550px'
});
var centerSpinnerStyle = xcss({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  marginTop: 'space.300'
});
export var ReactionView = function ReactionView(_ref) {
  var selectedEmojiId = _ref.selectedEmojiId,
    emojiProvider = _ref.emojiProvider,
    reaction = _ref.reaction,
    ProfileCardWrapper = _ref.ProfileCardWrapper;
  var alphabeticalNames = useMemo(function () {
    var _reactionObj$users;
    var reactionObj = reaction;
    return ((_reactionObj$users = reactionObj.users) === null || _reactionObj$users === void 0 ? void 0 : _reactionObj$users.sort(function (a, b) {
      return a.displayName.localeCompare(b.displayName);
    })) || [];
  }, [reaction]);
  return jsx(TabPanel, null, jsx(Flex, {
    direction: "column",
    xcss: reactionViewStyle
  }, alphabeticalNames.length === 0 ?
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  jsx(Box, {
    xcss: centerSpinnerStyle
  }, jsx(Spinner, {
    size: "large"
  })) :
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  jsx("ul", {
    css: userListStyle
  }, alphabeticalNames.map(function (user) {
    var _user$profilePicture;
    var profile = (_user$profilePicture = user.profilePicture) === null || _user$profilePicture === void 0 ? void 0 : _user$profilePicture.path;
    return (
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      jsx("li", {
        css: userStyle,
        key: user.id
      }, ProfileCardWrapper && user.accountId ? jsx(Box, {
        xcss: profileWrapperStyle
      }, jsx(ProfileCardWrapper, {
        userId: user.accountId,
        isAnonymous: false,
        canViewProfile: true,
        position: "left-start"
      }, jsx(Avatar, {
        size: "medium",
        src: profile,
        testId: "profile"
      }))) : jsx(Avatar, {
        size: "medium",
        src: profile,
        testId: "profile"
      }), jsx(Flex, {
        xcss: userDescriptionStyle
      }, jsx("div", null, user.displayName)))
    );
  }))));
};